import React, { useMemo } from 'react';
import { useTable } from 'react-table';
import { Checkbox, Button } from '@mantine/core';
import { Styles } from '../../../components/scopeComp/tableStyles';

export function LiquidsTable({
  liquids,
  setViewModal,
  values,
  setValues,
  disabled,
  disabledMaterials,
}) {
  const handleSelect = (event) => {
    const currentLiquids = [...values.reversal_scope];
    if (event.target.checked) {
      currentLiquids.push({
        scope_id: parseInt(event.target.name),
        material_id: null,
      });
    } else {
      const index = currentLiquids.findIndex((i) => i.scope_id === parseInt(event.target.name));
      if (index > -1) currentLiquids.splice(index, 1);
    }

    setValues({ reversal_scope: currentLiquids }, null, 'veam');
  };

  const columns = useMemo(
    () => [
      {
        Header: '',
        id: 'checkbox',
        Cell: ({ row }) => {
          const checked = (values?.reversal_scope || []).findIndex(
            (val) => parseInt(val.scope_id) === parseInt(row.original.id),
          );

          return (
            <Checkbox
              name={row.original.id}
              onChange={handleSelect}
              checked={checked > -1}
              disabled={disabled || disabledMaterials[row.original.id]}
            />
          );
        },
      },
      {
        Header: 'Liquid Code',
        accessor: 'selection_number',
      },
      {
        Header: 'Liquid Description',
        accessor: 'selection_name',
      },
      {
        Header: 'BOM',
        id: 'impacted_skus',
        Cell: ({ row }) => (
          <div>
            {' '}
            <Button
              color='dark'
              radius='xl'
              onClick={() =>
                setViewModal({
                  scope_id: row.original.id,
                  open: true,
                  type: 'liquids',
                })
              }
            >
              View
            </Button>
          </div>
        ),
      },
    ],
    [values, disabledMaterials],
  );

  const tableInstance = useTable({
    columns,
    data: liquids,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Styles>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: 'fitContent' }} {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()} id='header-row'>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Styles>
    </div>
  );
}
